import React from "react";

const FEATURES = [
    {
        title: "One-Stop Sustainability Partner ",
        description:
            "From ESG roadmaps to Net-Zero execution, we are your single-window partner for sustainable transformation. ",
        icon: '/assets/images/esg-advisory/future-ready.png',
        width: "3rem",
    },
    {
        title: "Measurable Results",
        description:
            "We design solutions with clear outcomes: improved efficiency, stronger reputation, and long-term profitability. ",
        icon: "/assets/images/esg-advisory/end-to-end.png",
        width: "3rem",
    },
    {
        title: "Future-Ready Solutions ",
        description: "From climate resilience to digital ESG dashboards, we prepare you to thrive in a changing world.",
        icon: "/assets/images/esg-advisory/future-ready-sol.png",
        width: "3rem"
    },
    {
        title: "Long-Term Collaboration",
        description:
            "We build trusted partnerships with clients - supporting you from strategy to execution.",
        icon: '/assets/images/esg-advisory/cross-functional.png',
        width: "2rem",
    },
    {
        title: "Shaping a Better Future",
        description:
            "Together, we build businesses that thrive responsibly while creating a balanced world for future generations.",
        icon: '/assets/images/esg-advisory/shaping-future.png',
        width: "3rem",
    },
    {
        title: "Purpose With Profitability",
        description:
            "Our approach ensures that sustainability isn’t a cost - it’s an investment. We align your business goals with ESG principles to unlock growth, trust, and long-term impact.",
        icon: '/assets/images/esg-advisory/purpose-probability.png',
        width: "4rem",
    },
];

export default function WhyNirantara() {
    return (
        <section className="flex flex-col items-center w-full gap-10 sm:gap-14 px-[2rem] py-[2rem] sm:px-[5rem] md:px-[5rem] lg:px-[15rem]  montserrat bg-[#FFF]">
            <h2 className="text-center text-3xl sm:text-4xl font-extrabold text-[#1A1A1A] my-4 sm:my-10">
                Why Nirantara?
            </h2>

            <div className="grid pr-0 md:grid-cols-2 sm:grid-cols-1">
                {FEATURES?.map((item, i) => (
                    <div
                        key={i}
                        className={`flex items-start gap-4 px-4 py-10 ${i < 4 ? 'border-b-2 border-gray-300' : ''}`}
                    >

                        <div className={`p-1 rounded-lg ${item.bgColor}`}>
                            <img src={item.icon} alt={item.title} style={{ width: item?.width }} />
                        </div>
                        <div>
                            <h3 className="mb-1 text-xl font-semibold text-gray-800">
                                {item.title}
                            </h3>
                            <p className="leading-relaxed text-gray-600 text-md text-justify">
                                {item.description}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}
